import { NavLink, useLocation } from 'react-router-dom';

import { isTabActive, SubHeaderTab } from '../Header/useSubHeaderTabs';

export const SubHeaderMenuItem = ({ tab }: { tab: SubHeaderTab }) => {
  const { pathname } = useLocation();

  const baseClasses =
    'block whitespace-nowrap px-6 py-[10px] text-gray-500 text-xsm border-b-2 no-underline transition-colors duration-200';
  const hoverClasses = 'hover:text-white light:hover:text-black';
  const activeClasses = 'border-accent-default text-foreground-default light:text-black';
  const disabledClasses = 'pointer-events-none text-gray-400';

  const inactiveBorder = 'border-transparent-0';

  return (
    <li className="flex list-none items-center self-end">
      <NavLink
        to={tab.to}
        className={
          tab.disabled
            ? `${baseClasses} ${disabledClasses}`
            : `${baseClasses} ${hoverClasses} ${
                isTabActive(tab, pathname) ? activeClasses : inactiveBorder
              }`
        }
      >
        {tab.label}
      </NavLink>
    </li>
  );
};
